import { toValidIndex as o } from "./index6.js";
function t(e, n) {
  return e[o(e, n)];
}
export {
  t as getByIndex
};
//# sourceMappingURL=index.js.map
